// extracted by mini-css-extract-plugin
export default {"description":"_52d1a1b0"};